import { render, staticRenderFns } from "./Buzzer.vue?vue&type=template&id=18635623&scoped=true&"
import script from "./Buzzer.vue?vue&type=script&lang=js&"
export * from "./Buzzer.vue?vue&type=script&lang=js&"
import style0 from "./Buzzer.vue?vue&type=style&index=0&id=18635623&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18635623",
  null
  
)

export default component.exports